import { useCancelPolicy } from "@/components/features/_hooks/use-cancel-policy/use-cancel-policy";
import { useAccommodationHotelPolicyFormModelContext } from "@/components/features/items/edit/hotel-policy/default/ui/context";

export const useCancelPolicyOfHotelPolicy = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { cancelPolicy } = viewModel;

	return useCancelPolicy({ cancelPolicy, onSetViewModel });
};
